import { render } from "./TaskManagementEnhanced.vue?vue&type=template&id=43967a5c&scoped=true"
import script from "./TaskManagementEnhanced.vue?vue&type=script&lang=js"
export * from "./TaskManagementEnhanced.vue?vue&type=script&lang=js"

import "./TaskManagementEnhanced.vue?vue&type=style&index=0&id=43967a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43967a5c"]])

export default __exports__